import React, { useEffect } from 'react';
import { withStyles, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Dialog, TextField, Switch } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import "../../SharedComponents/Elements/ToggleSwitch/ToggleSwitch.css";
import axios from 'axios'
//import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
//import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
//import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from "react-redux";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },

    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    myComponent: {
        "& .MuiSvgIcon-root": {
            background: `var(--red) !important`
        }
    }
}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {

    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {


    },
}))(MuiDialogActions);

const GrantAccessSwitch = withStyles({
    switchBase: {
        color: `var(--toggle-switch-color)`,
        '&$checked': {
            color: `var(--toggle-switch-checked-color)`,
        },
        '&$checked + $track': {
            backgroundColor: `var(--toggle-switch-bg-color)`,
        },
    },
    checked: {},
    track: {},
})(Switch);

const api = axios.create({
    baseURL: 'WorkCenterLoss'
})

export default function LossesDataForm(props) {
    const classes = useStyles();
    //for progress
    const [openLoader, setopenLoader] = React.useState(false);


    const [open, setOpen] = React.useState(false);
    const [defaultItem, setDefaultItem] = React.useState('');

    // Declare states
    const [amh, setamh] = React.useState('');
    const [createdBy, setcreatedBy] = React.useState('');
    const [entryDate, setentryDate] = React.useState(props.EntryDate);
    const [entryNumber, setentryNumber] = React.useState(props.EntryNumber);
    //const [hremarks, sethremarks] = React.useState('');
    const [machineBreakdown, setmachineBreakdown] = React.useState('');
    const [modifiedBy, setmodifiedBy] = React.useState('');
    const [mrpcontrollerId, setmrpcontrollerId] = React.useState(props.MRPControllerId);
    const [noOperator, setnoOperator] = React.useState('');
    const [noOrder, setnoOrder] = React.useState('');
    const [noRawMaterial, setnoRawMaterial] = React.useState('');
    const [noTool, setnoTool] = React.useState('');
    const [otherLosses, setotherLosses] = React.useState('');
    const [plannedLosses, setplannedLosses] = React.useState('');
    const [powerFailure, setpowerFailure] = React.useState('');
    const [remarks, setremarks] = React.useState('');
    const [toolBreakdown, settoolBreakdown] = React.useState('');
    const [totalAmh, settotalAmh] = React.useState('');
    const [totalLosses, settotalLosses] = React.useState('');
    const [workCenter, setworkCenter] = React.useState('');
    const [workCenterId, setworkCenterId] = React.useState('');
    const [workCenterLossDetId, setworkCenterLossDetId] = React.useState('');
    const [workCenterLossId, setworkCenterLossId] = React.useState(props.WorkCenterLossId);
    const [workerShiftId, setworkerShiftId] = React.useState(props.WorkerShiftId);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);


    //const handleRegistrationFormClickOpen = () => {
    //    setOpen(true);
    //};

    const handleRegistrationFormClickClose = () => {
        setOpen(false);
        props.clickgoback();
    };

    const handleRegistrationFormClickSubmit = () => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        let WClossDet = {
            WorkCenterLossId: Number(workCenterLossId),
            WorkCenterLossDetId: Number(workCenterLossDetId),
            EntryNumber: entryNumber,
            EntryDate: entryDate,
            MrpcontrollerId: Number(mrpcontrollerId),
            WorkerShiftId: Number(workerShiftId),
            Status: 1,
            WorkCenterId: workCenterId,
            Amh: amh,
            ToolBreakdown: toolBreakdown,
            MachineBreakdown: machineBreakdown,
            PowerFailure: powerFailure,
            NoOperator: noOperator,
            NoRawMaterial: noRawMaterial,
            NoTool: noTool,
            NoOrder: noOrder,
            OtherLosses: otherLosses,
            PlannedLosses: plannedLosses,
            TotalLosses: totalLosses,
            TotalAmh: totalAmh,
            Remarks: remarks,
            CreatedBy: props.loginuser.response.employeeId,
            ModifiedBy: props.loginuser.response.employeeId
        }

        api.post("/saveWorkCenterLossDetails/", WClossDet,{
            headers: headers
        })
            .then(res => {
                setopenLoader(false);
                props.getDataOnSubmit(res.data);
                handleRegistrationFormClickClose();
            })
            .catch(error => {
                console.log(error);
                handleRegistrationFormClickClose();
            })
    };

    const [state, setState] = React.useState({
        toggleSwitchChecked: true,
    });

    //const handleToggleSwitchChange = (event) => {
    //    setState({ ...state, [event.target.name]: event.target.checked });
    //};
    
    //const handleChange = (event) => {
    //    setDefaultItem(event.target.value);
    //};

    function setState_FetchData(rowData) {
        //console.log(rowData);    
        setopenLoader(true);
        setamh(rowData.amh);
        setcreatedBy(rowData.createdBy);
        setentryDate(rowData.entryDate);
        setentryNumber(rowData.entryNumber);
        setremarks(rowData.hremarks);
        setmachineBreakdown(rowData.machineBreakdown);
        setmodifiedBy(rowData.modifiedBy);
        setmrpcontrollerId(rowData.mrpcontrollerId);
        setnoOperator(rowData.noOperator);
        setnoOrder(rowData.noOrder);
        setnoRawMaterial(rowData.noRawMaterial);
        setnoTool(rowData.noTool);
        setotherLosses(rowData.otherLosses);
        setplannedLosses(rowData.plannedLosses);
        setpowerFailure(rowData.powerFailure);
        setremarks(rowData.remarks);
        settoolBreakdown(rowData.toolBreakdown);
        settotalAmh(rowData.totalAmh);
        settotalLosses(rowData.totalLosses);
        setworkCenter(rowData.workCenter);
        setworkCenterId(rowData.workCenterId);
        setworkCenterLossDetId(rowData.workCenterLossDetId);
        setworkCenterLossId(rowData.workCenterLossId);
        setworkerShiftId(rowData.workerShiftId);
        setopenLoader(false);
    }

    const handleChangeToolBreakdown = (event) => {
        settoolBreakdown(event.target.value);
        calculateTotalLosses(event.target.value, machineBreakdown, powerFailure, noOperator, noRawMaterial, noTool, noOrder, otherLosses, plannedLosses);
    };

    const handleChangeMachineBreakdown = (event) => {
        setmachineBreakdown(event.target.value);
        calculateTotalLosses(toolBreakdown, event.target.value, powerFailure, noOperator, noRawMaterial, noTool, noOrder, otherLosses, plannedLosses);
    };

    const handleChangePowerFailure = (event) => {
        setpowerFailure(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, event.target.value, noOperator, noRawMaterial, noTool, noOrder, otherLosses, plannedLosses);
    };

    const handleChangeNoOperator = (event) => {
        setnoOperator(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, event.target.value, noRawMaterial, noTool, noOrder, otherLosses, plannedLosses);
    };

    const handleChangeNoRawMaterial = (event) => {
        setnoRawMaterial(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, noOperator, event.target.value, noTool, noOrder, otherLosses, plannedLosses);
    }

    const handleChangeNoTool = (event) => {
        setnoTool(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, noOperator, noRawMaterial, event.target.value, noOrder, otherLosses, plannedLosses);
    };

    const handleChangeNoOrder = (event) => {
        setnoOrder(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, noOperator, noRawMaterial, noTool, event.target.value, otherLosses, plannedLosses);
     };

    const handleChangeOtherLosses = (event) => {
        setotherLosses(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, noOperator, noRawMaterial, noTool, noOrder, event.target.value, plannedLosses);
    };

    const handleChangePlannedLosses = (event) => {
        setplannedLosses(event.target.value);
        calculateTotalLosses(toolBreakdown, machineBreakdown, powerFailure, noOperator, noRawMaterial, noTool, noOrder, otherLosses, event.target.value);
    };       
       
    function calculateTotalLosses(pToolBreakdown, pMachineBreakdown, pPowerfailure, pNoOperator, pNoRawMaterial, pNoTool, pNoOrder,pOtherLosses, pPlannedLosses ) {
        let totalLosses = Number(pToolBreakdown) + Number(pMachineBreakdown) + Number(pPowerfailure) + Number(pNoOperator) + Number(pNoRawMaterial) + Number(pNoTool) + Number(pNoOrder) + Number(pOtherLosses) + Number(pPlannedLosses);
        settotalLosses(totalLosses);

        let totalAMH = Number(amh) + totalLosses
        settotalAmh(totalAMH);
    }

    const handleChangeRemarks = (event) => {
        setremarks(event.target.value);
    };

    useEffect(() => {
        if (props.isDialogOpen) {
            setOpen(props.isDialogOpen);
            setState_FetchData(props.editData);
        }
    }, [props.isDialogOpen, props.editData]);

    return (
        <ThemeProvider theme={lightTheme}>
            <Dialog
                onClose={handleRegistrationFormClickClose}
                aria-labelledby="losses-data--form"
                open={open}
                maxWidth={"md"}
            >
                <DialogTitle className="clr-000028" id="losses-data--form" onClose={handleRegistrationFormClickClose}>
                    Add WorkCenter Losses
                </DialogTitle>
                <DialogContent>
                    <form className={classes.root} noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField id="workcenter" value={workCenter} fullWidth label="Work Center" variant="filled" disabled="true" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="amh" value={amh} fullWidth label="AMH (Worker Loaded)" variant="filled" disabled="true" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="tool_breakdown" value={toolBreakdown} onChange={handleChangeToolBreakdown} fullWidth label="Tool Breakdown" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="machine_breakdown" value={machineBreakdown} onChange={handleChangeMachineBreakdown} fullWidth label="Machine Breakdown" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="power_failure" value={powerFailure} onChange={handleChangePowerFailure} fullWidth label="Power Failure" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="no_operator" value={noOperator} onChange={handleChangeNoOperator} fullWidth label="No Operator" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="no_raw_material" value={noRawMaterial} onChange={handleChangeNoRawMaterial} fullWidth label="No Raw Material" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="no_tool" value={noTool} onChange={handleChangeNoTool} fullWidth label="No Tool" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="no_order" value={noOrder} onChange={handleChangeNoOrder} fullWidth label="No Order" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="other_losses" value={otherLosses} onChange={handleChangeOtherLosses} fullWidth label="Other Losses" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="planned_losses" value={plannedLosses} onChange={handleChangePlannedLosses} fullWidth label="Planned Losses" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <textarea className="lightInputFields bgtextarea_wcl"
                                    id="remarks"
                                    label="Remarks"
                                    placeholder="Remarks"
                                    variant="filled"
                                    name="Remarks"
                                    value={remarks}
                                    onChange={handleChangeRemarks}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="total_losses" value={totalLosses} fullWidth label="Total Losses" variant="filled" disabled="true" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="total_amh" value={totalAmh} fullWidth label="Total AMH" variant="filled" disabled="true" />
                            </Grid>                            
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Grid container>
                        <Grid item xs={5}>
                            <Button className="e-performance-button--tertiary" onClick={handleRegistrationFormClickClose}>
                                &lt; Go Back
                            </Button>
                        </Grid>
                        <Grid item xs={7} className="d-flex">
                            <Button className="e-performance-button--primary width-25 f-20" onClick={handleRegistrationFormClickSubmit}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={openLoader}
                        //onClose={handleClose}
                        aria-labelledby="draggable-dialog-title"
                        id="templateUploadSuccess"
                        PaperProps={{
                            style: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                borderColor: "transparent"
                            },
                        }}>
                        <DialogContent>
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}


